<div class="fiche-consultant-profil__header">
  <div class="fiche-consultant-profil__header__left">
    <div class="fiche-consultant-profil__header__identite fiche-consultant-card">
      <div class="headline-6">Identité</div>
      <div>
        <oui-pair-info
          level="secondary"
          [editable]="false"
          label="Adresse"
          [value]="consultant().adresse"></oui-pair-info>
        <oui-pair-info
          level="secondary"
          [editable]="false"
          label="Téléphone"
          [value]="consultant().telephone"></oui-pair-info>
        <oui-pair-info
          class="email-pair-info"
          level="secondary"
          [editable]="false"
          label="E-mail"
          [value]="consultant().email"></oui-pair-info>
      </div>
    </div>

    @if (consultant().siegeSocial) {
      <div class="fiche-consultant-profil__header__siege-social fiche-consultant-card">
        <div class="headline-6">Siège social</div>
        <div>
          <oui-pair-info
            level="secondary"
            [editable]="false"
            label="Adresse"
            [value]="consultant().siegeSocial"></oui-pair-info>
        </div>
      </div>
    }
  </div>

  <div class="fiche-consultant-profil__header__right">
    <div class="fiche-consultant-profil__header__evenements fiche-consultant-card">
      <div class="headline-6">Évènements importants</div>
    </div>
  </div>
</div>

@if (consultant().statutJuridiqueImmo || consultant().statutJuridiqueNonImmo) {
  <div class="headline-6">Statuts juridiques</div>

  <div class="fiche-consultant-profil__statuts-juridiques">
    @if (consultant().statutJuridiqueImmo) {
      <div
        class="fiche-consultant-profil__statuts-juridiques__immo fiche-consultant-card">
        <div class="headline-6">Activité immobilière</div>
        <div>
          <oui-pair-info
            level="secondary"
            [editable]="false"
            label="Statut"
            [value]="consultant().statutJuridiqueImmo?.statutLibelle"></oui-pair-info>

          @if (consultant().statutJuridiqueImmo?.numeroCarteT) {
            <oui-pair-info
              level="secondary"
              [editable]="false"
              label="N* Carte T"
              [value]="consultant().statutJuridiqueImmo?.numeroCarteT"></oui-pair-info>
            <oui-pair-info
              level="secondary"
              [editable]="false"
              label="Date d'expiration"
              [value]="
                consultant().statutJuridiqueImmo?.dateExpirationCarteT
                  | date: 'dd/MM/yyyy'
              "></oui-pair-info>
            <oui-pair-info
              level="secondary"
              [editable]="false"
              label="CCI de délivrance"
              [value]="
                consultant().statutJuridiqueImmo?.cciDelivranceCarteT
              "></oui-pair-info>
          }
          @if (
            consultant().statutJuridiqueImmo?.statut === 'societe' ||
            consultant().statutJuridiqueImmo?.statut === 'profession_liberale'
          ) {
            @if (consultant().statutJuridiqueImmo?.statut === 'societe') {
              <oui-pair-info
                level="secondary"
                [editable]="false"
                label="Raison sociale"
                [value]="consultant().statutJuridiqueImmo?.raisonSociale"></oui-pair-info>
              <oui-pair-info
                level="secondary"
                [editable]="false"
                label="Type"
                [value]="
                  consultant().statutJuridiqueImmo?.formeJuridique
                "></oui-pair-info>
              <oui-pair-info
                level="secondary"
                [editable]="false"
                label="N° SIRET"
                [value]="
                  consultant().statutJuridiqueNonImmo?.numeroSiret ?? '---'
                "></oui-pair-info>
            } @else {
              <oui-pair-info
                level="secondary"
                [editable]="false"
                label="N° SIREN"
                [value]="
                  consultant().statutJuridiqueNonImmo?.numeroSiret ?? '---'
                "></oui-pair-info>
            }

            <oui-pair-info
              level="secondary"
              [editable]="false"
              label="N° TVA intracommunautaire"
              [value]="
                consultant().statutJuridiqueImmo?.numeroTva ?? '-'
              "></oui-pair-info>
          }
        </div>
      </div>
    }

    @if (consultant().statutJuridiqueNonImmo) {
      <div
        class="fiche-consultant-profil__statuts-juridiques__autre fiche-consultant-card">
        <div class="headline-6">
          Activité assurance, financement et placements financiers
        </div>
        <div>
          <oui-pair-info
            level="secondary"
            [editable]="false"
            label="Statut"
            [value]="consultant().statutJuridiqueNonImmo?.statutLibelle"></oui-pair-info>

          @if (
            consultant().statutJuridiqueNonImmo?.statut === 'societe' ||
            consultant().statutJuridiqueNonImmo?.statut === 'profession_liberale'
          ) {
            @if (consultant().statutJuridiqueNonImmo?.statut === 'societe') {
              <oui-pair-info
                level="secondary"
                [editable]="false"
                label="Raison sociale"
                [value]="
                  consultant().statutJuridiqueNonImmo?.raisonSociale
                "></oui-pair-info>
              <oui-pair-info
                level="secondary"
                [editable]="false"
                label="Type"
                [value]="
                  consultant().statutJuridiqueNonImmo?.formeJuridique
                "></oui-pair-info>
              <oui-pair-info
                level="secondary"
                [editable]="false"
                label="N° SIRET"
                [value]="
                  consultant().statutJuridiqueNonImmo?.numeroSiret ?? '---'
                "></oui-pair-info>
            } @else {
              <oui-pair-info
                level="secondary"
                [editable]="false"
                label="N° SIREN"
                [value]="
                  consultant().statutJuridiqueNonImmo?.numeroSiret ?? '---'
                "></oui-pair-info>
            }

            <oui-pair-info
              level="secondary"
              [editable]="false"
              label="N° TVA intracommunautaire"
              [value]="
                consultant().statutJuridiqueNonImmo?.numeroTva ?? '---'
              "></oui-pair-info>
          }
        </div>
      </div>
    }
  </div>
}

@if (appAudience === 'consultant') {
  <div class="headline-6">Compte</div>
  <div class="fiche-consultant-profil__compte">
    <oui-button
      type="outlined"
      [disabled]="disableResiliation()"
      (click)="requestResiliation.emit()"
      >Cesser mon activité</oui-button
    >
  </div>
}
